module.exports = __webpack_public_path__ + "img/xinzhuang-5.949f4e75.jpg";